<label class="form-control-label">Sort order</label>
<cdk-virtual-scroll-viewport
  appendOnly
  class="sort-container"
  dndDropzone
  (dndDrop)="onDrop($event, true)"
  itemSize="24"
>
  <div class="loading-container" *ngIf="loading">
    <mode-animated-refresh-icon></mode-animated-refresh-icon>
    <span class="loading-text">Loading values&hellip;</span>
  </div>
  <div class="list-dropzone" dndDropzone (dndDrop)="onDrop($event, false)" *ngIf="!loading">
    <div class="placeholder-field" dndPlaceholderRef>
      <div class="cursor-left"></div>
      <div class="cursor-right"></div>
    </div>
    <div
      *cdkVirtualFor="let item of orderedItems; let i = index"
      class="row sort-item-container"
      dndEffectAllowed="move"
      (dndStart)="onDragStart($event, item)"
      [dndDraggable]="item"
    >
      <div class="sort-item">
        {{ formatter(item) + '' }}
        <capra-icon
          *ngIf="i >= maxSortableValues"
          icon="icon-info-outline"
          capraTooltip
          [tooltipContent]="tooltipContent"
          tooltipPlacement="bottom"
          tooltipSize="regular-thin"
          [tooltipInteractive]="tooltipInteractivity"
        ></capra-icon>
      </div>
      <div class="col-md-2 move-to-top" *ngIf="i !== 0">
        <a class="move-to-top-link" (click)="moveToTop(item)">Move to top</a>
      </div>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
<span class="sort-disclaimer">If the data source changes, new values will be added to the end of the list.</span>
